import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Paper, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import { useAuth } from "../../authentication/AuthProvider";
import RefreshButton from "../../components/button/RefreshButton";
import PivotableBarChart from "../../components/chart/PivotableBarChart";
import PivotablePieChart from "../../components/chart/PivotablePieChart";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import { TableHeaderContainer } from "../../components/container/TableHeaderContainer";
import { TableHeaderToolsContainer } from "../../components/container/TableHeaderToolsContainer";
import { TableTitleContainer } from "../../components/container/TableTitleContainer";
import ContextMenu from "../../components/context-menu/ContextMenu";
import DialogDelete from "../../components/dialog/DialogDelete";
import ExportAsXLSXButton from "../../components/export/ExportAsXLSXButton";
import { centerAlignColDef, defaultColDef, floatFormater, leftAlignColDef, rightAlignColDef } from "../../components/grid/columnDefinitions/columnDefinitions";
import SearchBox from "../../components/input/SearchBox";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import ThirdTabs from "../../components/tabs/ThirdTabs";
import { Process } from "../../db_access/process";
import Footprint from "../../environment-page-components/Footprint";
import SankeyDiagram from "../../environment-page-components/SankeyDiagram";
import SystemBoundary from "../../environment-page-components/SystemBoundary";
import muiSytle from "../../style/components-style/muiStyle";
import "../../style/sidemenu-pages-style/UserLibrary.css";
import DialogSend from "../Products/Collaborate/DialogSend";
import { deleteProduct, deleteProject, getInternalCollaboratesProduct, getInternalCollaboratesProject, uncollaborateProduct, uncollaborateProject } from "./CollaborateDashboard";
const CollaborateInternal = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { refresh, setRefresh } = useContextProvider();
  const pageType = "supplier";
  const [internalCollaborates, setInternalCollaborates] = useState([]);

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [processData, setProcessData] = useState([]);
  const [height, setHeight] = useState(600);
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const gridRef = useRef(null);
  const dialogDeleteRef = useRef(null);
  const dialogRef = useRef();
  const handleOpenDialog = () => dialogRef.current?.open();
  const internal = { label: t("Internal"), value: "internal" };
  const stats = { label: "Stats", value: "Stats" };
  let tabs = [internal, stats];
  const isCompanAdmin = user["is_company_admin"] === 1;
  const [selectedTab, setSelectedTab] = useState(internal.value);
  const [searchText, setSearchText] = useState("");
  const getInternalCollaborates = () => {
    Promise.all([getInternalCollaboratesProduct(), getInternalCollaboratesProject()])
      .then(([products, projects]) => setInternalCollaborates([...products, ...projects]))
      .catch((error) => console.error("Error fetching data:", error));
  };
  const uncollaborate = (collaborates) => {
    Promise.all([uncollaborateProduct(collaborates), uncollaborateProject(collaborates)])
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => setRefresh((r) => !r));
  };
  const deleteCollaborates = (collaborates) => {
    Promise.all([deleteProduct(collaborates), deleteProject(collaborates)])
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setSelectedProducts([]);
        setRefresh((r) => !r);
      });
  };
  const getProcesses = () => {
    Process.get_by_product_ids(selectedProducts.map((i) => i.id))
      .then((res) => res.json())
      .then((data) => setProcessData(data));
  };

  const onSelectionChanged = (event) => {
    const selected = event.api.getSelectedRows();
    setSelectedProducts(selected);
  };
  const handleContextMenu = (e) => {
    e.preventDefault();
    setMenuPosition({ x: e.pageX, y: e.pageY });
    setMenuVisible(true);
  };
  const handleCloseMenu = () => {
    setMenuVisible(false);
  };
  const openDialogDelete = () => {
    if (dialogDeleteRef) {
      dialogDeleteRef.current.open();
    }
  };
  const columnDefs = [
    { field: "id", hide: true },
    { headerName: t("Name"), field: "name", cellStyle: { fontWeight: 600, ...leftAlignColDef.cellStyle }, ...defaultColDef },
    { headerName: t("Type"), field: "_type", ...defaultColDef, ...centerAlignColDef },
    { headerName: t("Username"), field: "username", ...defaultColDef, ...centerAlignColDef },
    { headerName: t("GWP (kgCO2)"), field: "gwp", cellStyle: { fontWeight: 500, ...rightAlignColDef.cellStyle }, ...defaultColDef, ...floatFormater },
  ];
  const retrieve = { label: "Retrieve", action: uncollaborate, needSelectedItems: true };
  const send = { label: "Send", action: handleOpenDialog, needSelectedItems: true };
  const delete_collaborate = { label: "Delete", action: openDialogDelete, needSelectedItems: true };
  let contextMenuOptionsInternal = [retrieve];
  if (isCompanAdmin) {
    contextMenuOptionsInternal.push(send);
    contextMenuOptionsInternal.push(delete_collaborate);
  }
  const is_internal = selectedTab === internal.value;
  const is_stats = selectedTab === stats.value;

  const contextMenuOptions = contextMenuOptionsInternal;
  const productsGridProps = {
    rowSelection: {
      mode: "multiRow",
      headerCheckbox: true,
      checkboxes: true,
      enableClickSelection: true,
    },
    columnDefs: columnDefs,
    rowData: internalCollaborates,
    domLayout: "autoHeight",
    onSelectionChanged: onSelectionChanged,
    getRowId: (params) => String(params.data.id),
  };
  useEffect(() => getInternalCollaborates(), [refresh]);
  useEffect(() => {
    if (selectedProducts.length === 0) {
      setProcessData([]);
    } else {
      getProcesses();
    }
  }, [selectedProducts]);
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setGridOption("quickFilterText", searchText);
    }
  }, [searchText]);
  return (
    <MainContainer>
      <PageTitleContainer>
        <Typography variant="Page Title">{t("Collaborate Dashoboard")}</Typography>
      </PageTitleContainer>
      <Box sx={{ paddingBottom: 2 }}>
        <ThirdTabs options={tabs} selected={selectedTab} setSelected={setSelectedTab} />
      </Box>

      <Box sx={{ display: is_internal ? "block" : "none" }}>
        <Paper variant="Table Container">
          <TableHeaderContainer>
            <TableTitleContainer>
              <Typography variant="Table Title">
                {internal.label} {t("Collaborate Library")}
              </Typography>
            </TableTitleContainer>
            <TableHeaderToolsContainer>
              <SearchBox text={searchText} setText={setSearchText} />
              <ExportAsXLSXButton data={internalCollaborates} label="Export as .xlsx" filename="products.xlsx" />
              <RefreshButton />
            </TableHeaderToolsContainer>
          </TableHeaderContainer>
          <Box>
            <ResizableBox
              width={Infinity}
              height={height}
              minConstraints={[100, 500]}
              maxConstraints={[Infinity, 800]}
              resizeHandles={["se"]}
              handle={(resizeHandle, ref) => (
                <Box
                  ref={ref}
                  className="custom-resize-handle"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "20px",
                    height: "20px",
                    cursor: "se-resize",
                  }}>
                  <Icon icon="vaadin:handle-corner" style={{ color: "grey", fontSize: "20px" }} />
                </Box>
              )}
              onResizeStop={(_, data) => {
                setHeight(data.size.height);
              }}>
              <Box className="ag-theme-alpine grid-container" onContextMenu={handleContextMenu}>
                <AgGridReact {...productsGridProps} ref={gridRef} domLayout="normal" />
              </Box>
            </ResizableBox>
          </Box>
        </Paper>
        <Box
          sx={{
            display: selectedProducts.length === 1 ? "block" : "none",
            paddingY: 1,
          }}>
          <SystemBoundary processData={processData} />
          <Footprint processData={processData} pageType={pageType} />
          <SankeyDiagram processData={processData} />
        </Box>
        <DialogSend ref={dialogRef} selectedItems={selectedProducts} />
        <ContextMenu x={menuPosition.x} y={menuPosition.y} visible={menuVisible} onClose={handleCloseMenu} selectedItems={selectedProducts} options={contextMenuOptions} />
        <DialogDelete selectedItems={selectedProducts} handleDelete={deleteCollaborates} ref={dialogDeleteRef} />
      </Box>
      <Box sx={{ display: is_stats ? "block" : "none" }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          <Paper variant="Table Container">
            <Box sx={{ width: 500, height: 500 }}>
              <PivotablePieChart title={"Colleagues Collaborates"} usages={internalCollaborates} groupBy={"_type"} countBy={"gwp"} />
            </Box>
          </Paper>
          <Paper sx={muiSytle.chartContainer}>
            <PivotableBarChart title={"Colleagues Collaborates"} usages={internalCollaborates} groupBy={"_type"} countBy={"gwp"} isLogarithm={true} />
          </Paper>
          <Paper variant="Table Container">
            <Box sx={{ width: 500, height: 500 }}>
              <PivotablePieChart title={"Colleagues Collaborates"} usages={internalCollaborates} groupBy={"username"} countBy={"gwp"} />
            </Box>
          </Paper>
          <Paper sx={muiSytle.chartContainer}>
            <PivotableBarChart title={"Colleagues Collaborates"} usages={internalCollaborates} groupBy={"username"} countBy={"gwp"} isLogarithm={true} />
          </Paper>
        </Box>
      </Box>
    </MainContainer>
  );
};

export default CollaborateInternal;
